export default {
  title: 'Bookingnotifikationer',
  label: 'Hvor skal vi sende notifikationer om reservationer?',
  placeholder: 'f.eks. booking@dinrestaurant.dk',
  helper:
    'Alle e-mailadresser virker — det kræver ikke adgang til dashboardet. Du kan ændre det eller tilføje flere senere under Reservationer → Indstillinger → Notifikationer og bekræftelse.',
  errors: {
    required: 'Tilføj en e-mailadresse, så du får bookingnotifikationer.',
    invalid: 'Indtast en gyldig e-mailadresse, f.eks. navn@restaurant.dk.',
  },
};
